<template>
  <panel>
    <p class="mb-5">You can link up your Twitter and Facebook pages to automatically update with any videoettes or branded videos you create through our system.</p>
    <div class="flex items-start">
      <social-button name="twitter" class="bg-blue-light text-white mr-10" />
      <social-button name="facebook" class="bg-blue-dark text-white" />
    </div>
  </panel>
</template>

<script>
import SocialButton from '@/components/SocialButton'

export default {
  components: {
    SocialButton
  }
}
</script>
